// extracted by mini-css-extract-plugin
module.exports = {"root":"MemberHeaderColumn_root__3Mom5","label":"MemberHeaderColumn_label__2cYCv"};